import Joi from 'joi';
import { rutValidation } from '../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  serie: Joi.string()
    .min(9)
    .alphanum()
    .error(new Error('El N° de documento debe contener al menos 9 caracteres alfanuméricos.')),
});